export enum UploadPanelTabs {
  Upload = 0,
  Uploaded = 1,
}
